import fetchClient from './fetchClient';

import { errorHandler } from './utils';


const config = (isExternalPage: boolean = false) => {
    return {
        headers: {
            Authorization:
                'Bearer ' +
                localStorage.getItem(
                    isExternalPage ? 'delivery-token' : 'token',
                ),
        },
    };
};

export const getPaginatedRecurringOrders = async (
    page: number,
    limit: number,
    search: string,
) => {
    const res: any = await fetchClient
        .get(
            `/recurring-orders?limit=${limit}&page=${page}&search=${search}`,
            config(),
        )
        .catch((err) => {
            return null;
        });
    if (!res) return null;
    return res.data;
};

export const getRecurringOrder = async (id: string) => {
    const res = await fetchClient
        .get(`/recurring-orders/${id}`, config())
        .catch((err) => {
            return null;
        });
    if (!res) return null;
    return res.data;
};

export const updateRecurringOrder = async (customer: any) => {
    const id = customer._id;
    delete customer._id;
    const res: any = await fetchClient
        .put(`/recurring-orders/${id}`, customer, config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const deleteRecurringOrder = async (id: string) => {
    const res: any = await fetchClient
        .delete(`/recurring-orders/${id}`, config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const createRecurringOrder = async (customer: any) => {
    const res = await fetchClient
        .post('/recurring-orders', customer, config())
        .catch(errorHandler);
    return res.data;
};
